import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    no: "01",
    title: "We start with outcomes, not tools.",
    body: "Before a single model is trained, we define the business result that matters — in revenue, cost or risk. Technology follows the outcome, never the other way around.",
  },
  {
    no: "02",
    title: "We embed AI where it compounds.",
    body: "We target the leverage points inside your operations where intelligence doesn't just help once, but improves every time it runs — creating advantage that accrues quietly and relentlessly.",
  },
  {
    no: "03",
    title: "We measure everything that matters.",
    body: "Every system we deploy is instrumented from day one. You see the impact in the numbers, and so does your board — accountability engineered into the work itself.",
  },
];

const APPROACH_IMG = "https://images.pexels.com/photos/30692588/pexels-photo-30692588.jpeg";

const Approach = () => (
  <section id="approach" data-testid="approach-section" className="bg-white px-6 py-28 lg:px-12 lg:py-40">
    <div className="mx-auto max-w-[1500px]">
      <Reveal>
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-cobalt">
          / How we work — a manifesto
        </span>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-24">
        {/* Sticky treated image */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <div className="relative overflow-hidden">
                <img
                  src={APPROACH_IMG}
                  alt="Prospera principal"
                  className="aspect-[3/4] w-full object-cover grayscale transition-all duration-700 hover:grayscale-0"
                />
                <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-black/10" />
                <div className="absolute bottom-0 left-0 bg-cobalt px-6 py-4">
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/70">
                    Est. principle
                  </div>
                  <div className="font-serif text-xl text-white">Outcomes over optics</div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>

        {/* Numbered chapters */}
        <div className="lg:col-span-7">
          <div className="divide-y divide-black/10 border-t border-black/10">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.08}>
                <div className="grid grid-cols-1 gap-6 py-14 sm:grid-cols-12" data-testid={`chapter-${c.no}`}>
                  <div className="sm:col-span-2">
                    <span className="font-serif text-5xl font-medium text-cobalt/25">{c.no}</span>
                  </div>
                  <div className="sm:col-span-10">
                    <h3 className="font-serif text-3xl font-medium leading-tight tracking-tight text-ink lg:text-4xl">
                      {c.title}
                    </h3>
                    <p className="mt-5 max-w-xl text-base font-light leading-relaxed text-ink/60">
                      {c.body}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Approach;
